/*--------------------------------------------------------------
    PAGE LAYOUT BOTTOM BAR
--------------------------------------------------------------*/

(function ($, Drupal, drupalSettings, once) {

  Drupal.behaviors.vscPageLayoutBottomBar = {

    attach: function (context, settings) {

      // Init Bottom Bar
      once('vscPageLayoutBottomBar', '.page-layout-bottom-bar', context).forEach(function (element) {

        const bottomBarStickyModifierClass = 'sticky--page-layout-bottom-bar';

        const bottomBarCalcHeight = () => {
          let bottomBarInnerHeight = element.offsetHeight;
          document.documentElement.style.setProperty('--page-layout-bottom-bar-height', `${bottomBarInnerHeight}px`);
        }

        const bottomBarShowHandler = () => {
          // Get window scroll position
          let scrollTop = $(window).scrollTop();
          // Get trigger element fixed offset from top
          let bottomBarTriggerOffset = $('.page-layout-bottom-bar-trigger').offset().top;
          // Calculate trigger element current scroll distance from top
          let distanceFromTop = bottomBarTriggerOffset - scrollTop;

          // Toggle a class if the trigger element is scrolled off the top of the page
          if (distanceFromTop < 0) {
            document.body.classList.add(bottomBarStickyModifierClass);
          } else {
            document.body.classList.remove(bottomBarStickyModifierClass);
          }
        }


        // Browser window Scroll function with Lodash throttle to every 300ms
        $(window).scroll(customLodash.throttle(function () {
          bottomBarShowHandler();
        }, 300));


        // Browser window resize event listener with lodash throttle
        window.addEventListener('resize', customLodash.throttle(function() {
          bottomBarCalcHeight();
        }, 300), true);



        // Bottom Bar add init modifier class
        element.classList.add('page-layout-bottom-bar--initialised');

        // Bottom Bar remove prevent transitions class modifier
        element.classList.remove('prevent-transitions');

        // Trigger bottomBarCalcHeight functions on page load
        bottomBarCalcHeight();
      });
    }
  }
} (jQuery, Drupal, drupalSettings, once));
